/* F+J site helpers
   1. "Visit us" block in the mobile menu
   2. Brand name on product cards and product page opens that brand's products
   3. Long product descriptions fold with "Read more"
   4. "Finish the look" accessories in the add-to-cart pop-up
   5. Product cards: one colour square + "+2" like COS
   6. "Our Brands" menu on computer: A–Z grouped by letter; short menus drop down under their item
   7. Computer header: country + Visit us + Account on the left, search box, wishlist and bag on the right
   8. Wishlist: hearts on products, saved on this device, shown on /pages/wishlist
   9. Sold-out pieces go last; on the home page they are hidden from the picks */
(function () {
  function addVisit() {
    var links = document.querySelector('#menu-drawer .menu-drawer__utility-links');
    if (!links || document.querySelector('.fj-drawer-visit')) return;
    var box = document.createElement('div');
    box.className = 'fj-drawer-visit';
    box.innerHTML =
      '<p class="fj-drawer-visit__title">Visit us in Blackrock</p>' +
      '<a class="fj-drawer-visit__call" href="tel:+35312108539">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 3h4l2 5-2.5 1.5a11 11 0 0 0 6 6L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2z"/></svg>' +
        'Call us (01) 210 8539' +
      '</a>' +
      '<p class="fj-drawer-visit__row">Monday to Saturday, 10 \u2013 5:30<br>Sunday closed</p>' +
      '<p class="fj-drawer-visit__row"><a href="https://www.google.com/maps/search/?api=1&query=Fran+%26+Jane+2a+Main+Street+Blackrock" target="_blank" rel="noopener">2a Main Street, Blackrock</a></p>';
    links.parentNode.insertBefore(box, links);
  }
 
  function linkBrands() {
    var vendors = document.querySelectorAll('.card-information .caption-with-letter-spacing');
    vendors.forEach(function (v) {
      if (v.querySelector('a')) return;
      var name = v.textContent.trim();
      if (!name) return;
      var a = document.createElement('a');
      a.className = 'fj-vendor-link';
      a.href = '/collections/vendors?q=' + encodeURIComponent(name);
      a.textContent = name;
      v.textContent = '';
      v.appendChild(a);
    });
  }
 
  function productPage() {
    var vendor = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.vendor;
    if (vendor) {
      document.querySelectorAll('.product__info-container > .product__text').forEach(function (t) {
        if (t.querySelector('a') || t.textContent.trim() !== vendor) return;
        var a = document.createElement('a');
        a.href = '/collections/vendors?q=' + encodeURIComponent(vendor);
        a.textContent = vendor;
        t.textContent = '';
        t.appendChild(a);
      });
    }
 
    var d = document.querySelector('.product__info-container > .product__description');
    if (!d || d.dataset.fjDesc) return;
    d.dataset.fjDesc = '1';
    if (d.scrollHeight < 320) return;
    d.classList.add('fj-desc--clamped');
    if (!d.id) d.id = 'fj-product-description';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fj-desc-toggle';
    b.setAttribute('aria-controls', d.id);
    b.setAttribute('aria-expanded', 'false');
    b.textContent = 'Read more';
    b.addEventListener('click', function () {
      var open = !d.classList.toggle('fj-desc--clamped');
      b.textContent = open ? 'Read less' : 'Read more';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    d.insertAdjacentElement('afterend', b);
  }
 
  function cardColours() {
    document.querySelectorAll('.card-color-swatches').forEach(function (box) {
      var s = box.querySelectorAll('.card-color-swatch');
      if (!s.length) return;
      if (!box.querySelector('.card-color-swatch.is-active')) s[0].classList.add('is-active');
      if (s.length > 1) box.setAttribute('data-more', '+' + (s.length - 1));
    });
  }
 
  /* "Our Brands" mega menu: A–Z grouped by letter (computer only) */
  var FJ_BRAND_NAMES = {
    'A VIEW': 'A-View', 'A-VIEW': 'A-View', 'A.KJÆRBEDE': 'A.Kjærbede', 'AMERICANDREAMS': 'American Dreams',
    'MEIMEIJ': 'Meimeij', 'KKNEKKI': 'Kknekki', 'CXC': 'CXC', 'RAINS': 'Rains', 'MIOH': 'Mioh',
    "LES FILLES D'AILLEURS": "Les Filles d'Ailleurs", 'LES TRICOTS DE LEA PARIS': 'Les Tricots de Léa Paris',
    'SILK95FIVE': 'Silk95five', 'NOTSHY CASHMERE': 'NotShy Cashmere', 'SCARLET POPPIES': 'Scarlett Poppies', 'SCARLETT POPPIES': 'Scarlett Poppies'
  };
  function brandName(raw) {
    var t = raw.replace(/\s+/g, ' ').trim();
    var key = t.toUpperCase();
    if (FJ_BRAND_NAMES[key]) return FJ_BRAND_NAMES[key];
    if (t === key) {
      return t.toLowerCase().replace(/(^|[\s.\-])([a-zà-ÿ])/g, function (m, a, b) { return a + b.toUpperCase(); });
    }
    return t;
  }
  function brandsMenu() {
    var menus = document.querySelectorAll('.header__inline-menu details.mega-menu');
    menus.forEach(function (d) {
      var summary = d.querySelector('summary');
      if (!summary) return;
      if (!/brand/i.test(summary.textContent)) {
        /* short menus (like Shop by category) drop down under their own item */
        if (d.querySelectorAll('.mega-menu__content a').length <= 14 && !d.classList.contains('fj-dd')) {
          d.classList.add('fj-dd');
          var place = function () {
            var c = d.querySelector('.mega-menu__content');
            var label = summary.querySelector('span') || summary;
            if (!c) return;
            var x = label.getBoundingClientRect().left - c.getBoundingClientRect().left;
            c.style.setProperty('--fj-dd-left', Math.max(0, Math.round(x)) + 'px');
          };
          d.addEventListener('toggle', place);
          summary.addEventListener('mouseenter', place);
          window.addEventListener('resize', place);
          place();
        }
        return;
      }
      var content = d.querySelector('.mega-menu__content');
      if (!content || content.querySelector('.fj-bm')) return;
      var seen = { 'a-view': true };
      /* extra brands that are not in the menu yet */
      var list = [{ name: 'A-View', href: '/collections/vendors?q=A%20VIEW' }];
      content.querySelectorAll('a').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.indexOf('/collections/') === -1) return;
        var name = brandName(a.textContent);
        var k = name.toLowerCase();
        if (seen[k]) return;
        seen[k] = true;
        list.push({ name: name, href: href });
      });
      if (list.length < 4) return;
      list.sort(function (a, b) { return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }); });
      var groups = {};
      var order = [];
      list.forEach(function (b) {
        var L = b.name.charAt(0).toUpperCase();
        if (!/[A-Z]/.test(L)) L = '#';
        if (!groups[L]) { groups[L] = []; order.push(L); }
        groups[L].push(b);
      });
      var html = '<div class="fj-bm page-width"><div class="fj-bm__cols">';
      order.forEach(function (L) {
        html += '<div class="fj-bm__group"><p class="fj-bm__letter" aria-hidden="true">' + L + '</p><ul class="fj-bm__list" role="list">';
        groups[L].forEach(function (b) {
          html += '<li><a class="fj-bm__link" href="' + b.href + '">' + b.name + '</a></li>';
        });
        html += '</ul></div>';
      });
      html += '</div>';
      html += '</div>';
      var box = document.createElement('div');
      box.innerHTML = html;
      content.classList.add('fj-bm-ready');
      content.appendChild(box.firstChild);
    });
  }
 
  /* ---------- Computer header: left links, search box, wishlist heart ---------- */
  var heartIcon = '<svg class="fj-heart-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.25 4.4 12.6a4.6 4.6 0 0 1 0-6.5 4.6 4.6 0 0 1 6.5 0L12 7.2l1.1-1.1a4.6 4.6 0 0 1 6.5 0 4.6 4.6 0 0 1 0 6.5L12 20.25z"/></svg>';
  var searchIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/></svg>';
 
  function headerDesktop() {
    var header = document.querySelector('header.header');
    if (!header || header.querySelector('.fj-hl')) return;
    var icons = header.querySelector('.header__icons');
    if (!icons) return;
 
    /* left side: country, Visit us, Account */
    var left = document.createElement('div');
    left.className = 'fj-hl';
    var loc = icons.querySelector('.desktop-localization-wrapper');
    if (loc) left.appendChild(loc);
    var globeIcon = '<svg class="fj-hl__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.3 2.4 3.4 5.2 3.4 8.5s-1.1 6.1-3.4 8.5c-2.3-2.4-3.4-5.2-3.4-8.5S9.7 5.9 12 3.5z"/></svg>';
    var pinIcon = '<svg class="fj-hl__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M12 21s-6.5-6.2-6.5-11.2a6.5 6.5 0 0 1 13 0C18.5 14.8 12 21 12 21z"/><circle cx="12" cy="9.8" r="2.3"/></svg>';
    var userIcon = '<svg class="fj-hl__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><circle cx="12" cy="8" r="3.8"/><path d="M4.5 20.5c.9-3.9 3.9-6 7.5-6s6.6 2.1 7.5 6"/></svg>';
    var locBtn = loc && loc.querySelector('.localization-form__select');
    if (locBtn && !locBtn.querySelector('.fj-hl__icon')) locBtn.insertAdjacentHTML('afterbegin', globeIcon);
    var visit = document.createElement('a');
    visit.className = 'fj-hl__link';
    visit.href = '/pages/contact-us';
    visit.innerHTML = pinIcon + '<span>Visit us</span>';
    left.appendChild(visit);
    var acc = icons.querySelector('.header__icon--account');
    if (acc) {
      var a2 = document.createElement('a');
      a2.className = 'fj-hl__link';
      a2.href = acc.getAttribute('href');
      a2.innerHTML = userIcon + '<span>Account</span>';
      left.appendChild(a2);
    }
    var leftSearch = header.querySelector(':scope > .header__search');
    if (leftSearch) leftSearch.insertAdjacentElement('afterend', left);
    else header.insertBefore(left, header.firstChild);
 
    /* right side: search box */
    var form = document.createElement('form');
    form.className = 'fj-hs';
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');
    form.innerHTML =
      '<label class="visually-hidden" for="fj-hs-q">Search</label>' +
      '<input id="fj-hs-q" class="fj-hs__input" type="search" name="q" placeholder="Search" autocomplete="off">' +
      '<input type="hidden" name="options[prefix]" value="last">' +
      '<button type="submit" class="fj-hs__btn" aria-label="Search">' + searchIcon + '</button>';
    icons.insertBefore(form, icons.firstChild);
    if (location.pathname === '/search') {
      var q = new URLSearchParams(location.search).get('q');
      if (q) form.querySelector('.fj-hs__input').value = q;
    }
 
    /* wishlist heart before the bag */
    var cart = icons.querySelector('.header__icon--cart');
    var wl = document.createElement('a');
    wl.className = 'fj-hw';
    wl.href = '/pages/wishlist';
    wl.setAttribute('aria-label', 'Wishlist');
    wl.innerHTML = heartIcon + '<span class="fj-hw__count" hidden></span>';
    if (cart) icons.insertBefore(wl, cart); else icons.appendChild(wl);
  }
 
  /* ---------- Wishlist (saved on this device) ---------- */
  var WL_KEY = 'fj-wishlist';
  function wlGet() {
    try { var v = JSON.parse(localStorage.getItem(WL_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function wlSet(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
    wlRefresh();
  }
  function wlToggle(handle) {
    var list = wlGet();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    wlSet(list);
  }
  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function wlRefresh() {
    var list = wlGet();
    var t = list.length ? String(list.length) : '';
    document.querySelectorAll('.fj-hw__count, .fj-drawer-wl__count').forEach(function (c) {
      if (c.textContent !== t) c.textContent = t;
      c.hidden = !list.length;
    });
    document.querySelectorAll('[data-fj-wl]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-fj-wl')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.querySelector('.fj-wl-btn__text');
      var lt = on ? 'Saved to wishlist' : 'Save to wishlist';
      if (label && label.textContent !== lt) label.textContent = lt;
    });
  }
  function wlCards() {
    document.querySelectorAll('.card-wrapper').forEach(function (w) {
      if (w.querySelector('.fj-heart')) return;
      var link = w.querySelector('a[href*="/products/"]');
      var info = w.querySelector('.card > .card__content .card__information') || w.querySelector('.card__information');
      var handle = link && handleFrom(link.getAttribute('href'));
      if (!handle || !info) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fj-heart';
      b.setAttribute('data-fj-wl', handle);
      b.setAttribute('aria-label', 'Save ' + (link.textContent.trim() || 'this piece') + ' to wishlist');
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = heartIcon;
      info.classList.add('fj-has-heart');
      info.appendChild(b);
    });
  }
  function wlProduct() {
    var handle = handleFrom(location.pathname);
    var info = document.querySelector('.product__info-container');
    if (!handle || !info || info.querySelector('.fj-wl-btn')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fj-wl-btn';
    b.setAttribute('data-fj-wl', handle);
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = heartIcon + '<span class="fj-wl-btn__text">Save to wishlist</span>';
    var buttons = info.querySelector('.product-form__buttons');
    if (buttons) { buttons.appendChild(b); return; }
    var buy = info.querySelector('product-form');
    var block = buy ? buy.closest('.product__info-container > *') : null;
    if (block) block.insertAdjacentElement('afterend', b); else info.appendChild(b);
  }
  function wlDrawer() {
    var visit = document.querySelector('.fj-drawer-visit');
    if (!visit || document.querySelector('.fj-drawer-wl')) return;
    var a = document.createElement('a');
    a.className = 'fj-drawer-wl';
    a.href = '/pages/wishlist';
    a.innerHTML = heartIcon + '<span>Wishlist</span><span class="fj-drawer-wl__count" hidden></span>';
    visit.parentNode.insertBefore(a, visit);
  }
  function priceText(cents) {
    var n = cents / 100;
    return '€' + (n % 1 ? n.toFixed(2) : n.toFixed(0));
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function wlPage() {
    if (!/^\/pages\/wishlist/.test(location.pathname)) return;
    var main = document.querySelector('main');
    if (!main || main.querySelector('.fj-wlp')) return;
    var host = main.querySelector('.fj-wlp-host') || main.querySelector('.rte');
    if (!host) return; /* nothing to draw into yet */
    var box = document.createElement('div');
    box.className = 'fj-wlp';
    host.appendChild(box);
    var list = wlGet();
    if (!list.length) {
      box.innerHTML = '<p class="fj-wlp__empty">Your wishlist is empty. Tap the heart on any piece to save it here.</p>' +
        '<a class="fj-wlp__shop" href="/collections/new-in">Shop new in</a>';
      return;
    }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var html = '<ul class="fj-wlp__grid" role="list">';
      items.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600') : '';
        html += '<li class="fj-wlp__item">' +
          '<a class="fj-wlp__img" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="fj-wlp__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
          '<span class="fj-wlp__vendor">' + esc(p.vendor) + '</span>' +
          '<span class="fj-wlp__price">' + priceText(p.price) + (p.available ? '' : ' · Sold out') + '</span>' +
          '<button type="button" class="fj-wlp__remove" data-remove="' + esc(list[i]) + '">Remove</button>' +
          '</li>';
      });
      html += '</ul>';
      box.innerHTML = html;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fj-wl]');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      wlToggle(b.getAttribute('data-fj-wl'));
      return;
    }
    var r = e.target.closest('.fj-wlp__remove');
    if (r) {
      var list = wlGet();
      var i = list.indexOf(r.getAttribute('data-remove'));
      if (i > -1) list.splice(i, 1);
      wlSet(list);
      var item = r.closest('.fj-wlp__item');
      if (item) item.remove();
      var box = document.querySelector('.fj-wlp');
      if (box && !box.querySelector('.fj-wlp__item')) { box.remove(); wlPage(); }
    }
  }, true);
 
  /* ---------- Sold-out pieces: last in every grid, hidden in home page picks ---------- */
  function isSoldOut(li) {
    if (li.querySelector('.price--sold-out')) return true;
    var b = li.querySelector('.card__badge .badge, .badge');
    return !!(b && /sold out/i.test(b.textContent));
  }
  function soldOutLast() {
    var home = location.pathname === '/';
    document.querySelectorAll('ul.product-grid, .collection ul.grid').forEach(function (ul) {
      if (ul.dataset.fjSorted) return;
      var items = Array.prototype.filter.call(ul.children, function (li) { return li.querySelector('.card-wrapper'); });
      if (!items.length) return;
      ul.dataset.fjSorted = '1';
      var sold = items.filter(isSoldOut);
      sold.forEach(function (li) { ul.appendChild(li); });
      if (!home || !ul.closest('.collection')) return;
      var avail = items.filter(function (li) { return sold.indexOf(li) === -1; });
      var m = (ul.className.match(/grid--(\d)-col-desktop/) || [])[1];
      var cols = m ? Number(m) : 4;
      if (avail.length < cols) return; /* not enough pieces in stock: keep the sold-out ones at the end */
      var keep = Math.floor(avail.length / cols) * cols;
      items.forEach(function (li) {
        var show = sold.indexOf(li) === -1 && avail.indexOf(li) < keep;
        li.classList.toggle('fj-hidden-card', !show);
      });
    });
  }
 
  /* ---------- Never A-Z by default: "all products" links and collections open by best selling ---------- */
  function fixAllLink(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.origin);
      if (u.origin !== location.origin) return;
      if (!/\/collections\/all\/?$/.test(u.pathname)) return;
      if (u.searchParams.has('sort_by')) return;
      u.searchParams.set('sort_by', 'best-selling');
      a.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function fixAllLinks() {
    document.querySelectorAll('a[href*="/collections/all"]').forEach(fixAllLink);
  }
  document.addEventListener('mousedown', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/collections/all"]');
    if (a) fixAllLink(a);
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/collections/all"]');
    if (a) fixAllLink(a);
  }, true);
  /* safety net: a collection that is set to A-Z in the admin opens by best selling instead.
     If the customer picks A-Z herself, the address has sort_by and nothing changes. */
  function noAlphabetical() {
    if (location.pathname.indexOf('/collections/') === -1) return;
    var params = new URLSearchParams(location.search);
    if (params.has('sort_by')) return;
    var sel = document.querySelector('select[name="sort_by"]');
    if (!sel || !/^title-/.test(sel.value)) return;
    if (!sel.querySelector('option[value="best-selling"]')) return;
    params.set('sort_by', 'best-selling');
    location.replace(location.pathname + '?' + params.toString() + location.hash);
  }
 
  function run() {
    noAlphabetical();
    fixAllLinks();
    soldOutLast();
    headerDesktop();
    brandsMenu();
    cardColours();
    productPage();
    addVisit();
    linkBrands();
    wlCards();
    wlProduct();
    wlDrawer();
    wlPage();
    wlRefresh();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
 
  /* "Finish the look" accessories in the "Item added to your cart" pop-up */
  var fjAccessories = null;
  function money(v) {
    var n = Number(v);
    return '€' + (n % 1 ? n.toFixed(2) : n.toFixed(0));
  }
  function loadAccessories() {
    if (fjAccessories) return Promise.resolve(fjAccessories);
    function get(handle) {
      return fetch('/collections/' + handle + '/products.json?limit=30')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    }
    /* uses the "Finish the look" collection if it exists, otherwise Accessories */
    return get('finish-the-look')
      .then(function (data) { return (data.products && data.products.length) ? data : get('accessories'); })
      .then(function (data) {
        fjAccessories = (data.products || []).filter(function (p) {
          return p.variants.length === 1 && p.variants[0].available && p.images && p.images.length;
        }).slice(0, 3);
        return fjAccessories;
      })
      .catch(function () { return []; });
  }
  var bagIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2L5 8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/><path d="M12 11.5v5M9.5 14h5"/></svg>';
  function popupLook() {
    var note = document.getElementById('cart-notification');
    if (!note || !note.classList.contains('active') || note.querySelector('.fj-pop')) return;
    var links = note.querySelector('.cart-notification__links');
    if (!links) return;
    loadAccessories().then(function (list) {
      if (!list.length || note.querySelector('.fj-pop')) return;
      var box = document.createElement('div');
      box.className = 'fj-pop';
      var html = '<p class="fj-pop__title">Finish the look</p><ul class="fj-pop__list" role="list">';
      list.forEach(function (p) {
        var img = p.images[0].src;
        img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        html += '<li class="fj-pop__item">' +
          '<div class="fj-pop__media">' +
            '<a class="fj-pop__img" href="/products/' + p.handle + '" tabindex="-1" aria-hidden="true"><img src="' + img + '" alt="" loading="lazy"></a>' +
            '<button type="button" class="fj-pop__add" data-id="' + p.variants[0].id + '" aria-label="Add ' + p.title.replace(/"/g, '&quot;') + ' to bag">' + bagIcon + '</button>' +
          '</div>' +
          '<a class="fj-pop__name" href="/products/' + p.handle + '">' + p.title + '</a>' +
          '<span class="fj-pop__price">' + money(p.variants[0].price) + '</span>' +
          '</li>';
      });
      html += '</ul>';
      box.innerHTML = html;
      links.parentNode.insertBefore(box, links);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fj-pop__add');
    if (!btn) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.id), quantity: 1 }] })
    }).then(function () { window.location.href = '/cart'; })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  });
  var fjNote = document.getElementById('cart-notification');
  if (fjNote) {
    new MutationObserver(popupLook).observe(fjNote, { attributes: true, attributeFilter: ['class'] });
  }
 
  /* new products loaded by filters or "load more" */
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () { linkBrands(); cardColours(); wlCards(); wlRefresh(); soldOutLast(); }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', run);
})();
 
